import { Injectable, InjectionToken, inject } from '@angular/core';
import { WINDOW_TOKEN } from './window.token';
import { Logger } from './logger/logger';
import { Level } from './logger/logger.domain';
import type { ErrorHandler } from '@angular/core';

interface Window {
  // Dynatrace agent - merging into Window interface
  dtrum: { reportError(error: Error | string, parentActionId?: undefined | number): void };
}

export const ERROR_LOG_LOCAL_CONFIGURATION = new InjectionToken<boolean>('logErrorsToConsole');

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {
  private readonly browserWindow = inject<Window>(WINDOW_TOKEN);
  private readonly devEnvironment = inject(ERROR_LOG_LOCAL_CONFIGURATION, { optional: true });

  private static readonly LOGGER: Logger = Logger.getLogger('ErrorHandlerService').setLevel(Level.ERROR);

  handleError(error: unknown): void {
    if (typeof error === 'string') {
      ErrorHandlerService.LOGGER.error(error);
    }

    if (typeof error === 'string' || error instanceof Error) {
      if (this.browserWindow.dtrum !== undefined && this.browserWindow.dtrum.reportError !== undefined) {
        this.browserWindow.dtrum.reportError(error);
      }
    }

    if(this.devEnvironment === true) {
      ErrorHandlerService.LOGGER.error('There was an error:', error);
    }
  }
}
